export default __webpack_public_path__ + "static/imgFour-14e5b8e25d8d9fd44f0c5023e7a36a6d.jpg";